import { useState, useEffect, useCallback } from "react";

interface UseDebouncedSearchTermOptions {
  initialValue?: string;
  delay?: number;
}

export const useDebouncedSearchTerm = (options?: UseDebouncedSearchTermOptions) => {
  const initialValue = options?.initialValue ?? "";
  const delay = options?.delay ?? 300;

  const [displayValue, setDisplayValue] = useState(initialValue);
  const [debouncedValue, setDebouncedValue] = useState(initialValue);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(displayValue);
    }, delay);
    return () => clearTimeout(handler);
  }, [displayValue, delay]);

  // Clears the input and its debounced value together, so a consumer's debounced query doesn't keep
  // filtering by the old term for one debounce window after a reset.
  const reset = useCallback(() => {
    setDisplayValue(initialValue);
    setDebouncedValue(initialValue);
  }, [initialValue]);

  return {
    displayValue,
    setDisplayValue,
    debouncedValue,
    reset,
  };
};
